import {
  take,
  fork,
  call,
  put,
  select,
} from 'redux-saga/effects';

import { apiGet } from './callApi';

import actionTypes from '../actionTypes';
import { successMission, failMission } from '../actionCreators/mission';
import { getToken } from '../selectors';

import apiRoutes from '../../constants/apiRoutes';

function* getMission(): any {
  try {
    const headers = {};
    const token = yield select(getToken);
    headers['x-access-token'] = JSON.stringify(token);
    const response = yield call(apiGet, 'REACT_APP_REMOTE_URL', apiRoutes.GET_MISSION, { token },
      headers);
    if (response.data.success) {
      yield put(successMission(response.data.result.wageringMissions));
    } else {
      yield put(failMission(response.data.message));
    }
  } catch (e) {
    yield put(failMission(e));
  }
}

export default function* watchMissionRequest() {
  while (true) {
    yield take(actionTypes.MISSION_REQUEST);
    yield fork(getMission);
  }
}
